import type {DataValue} from 'schemaDefinition/types';
import {isData, isVerifiedLinkedAgentLink} from 'schemaDefinition';
import type {Metadata} from '../types';

const setOnValue = (
  value: DataValue | undefined,
  agentId: string,
  verified: boolean,
): void => {
  if (Array.isArray(value)) {
    value.forEach(item => setOnValue(item, agentId, verified));
  } else if (isData(value)) {
    if (
      isVerifiedLinkedAgentLink(value) &&
      value.entityId === agentId &&
      value.agentVerified !== undefined
    ) {
      value.agentVerified = verified;
    }
    Object.values(value).forEach(child => setOnValue(child, agentId, verified));
  }
};

/** Mutates metadata, so call it on an Immer draft. */
export const setAgentVerifiedOnLinks = (
  metadata: Metadata | undefined,
  agentId: string,
  verified: boolean,
): void => {
  setOnValue(metadata as unknown as DataValue | undefined, agentId, verified);
};
